import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SystemInformationState {
  id: any;
  name: any;
  category: any;
  categoryId: any;
  price: any;
  description: any;
  manufacturer: any;
  systemInformationId: any;
  stock: any;
  imageLink: any;
  version: any;
  props: {
    [key: string]: any;
  };
}

const initialState: SystemInformationState = {
  id: '',
  name: '',
  category: '',
  categoryId: '',
  price: '',
  description: '',
  manufacturer: '',
  systemInformationId: '',
  stock: '',
  imageLink: '',
  version: '',

  props: { isModalVisible: false, refresh: false, isFinish: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const systemInformationSlice = createSlice({
  name: 'systemInformation',
  initialState,
  reducers: {
    setSystemInformation: (state, action: PayloadAction<Partial<SystemInformationState>>) => {
      return { ...state, ...action.payload };
    },

    resetSystemInformation: (_state, action: PayloadAction<Partial<SystemInformationState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: SystemInformationState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setSystemInformation, resetSystemInformation, updateField, updateProps } =
  systemInformationSlice.actions;

export default systemInformationSlice.reducer;
